import { render } from "./BusinessClassificationCreate.vue?vue&type=template&id=4a40f85a"
import script from "./BusinessClassificationCreate.vue?vue&type=script&lang=js"
export * from "./BusinessClassificationCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__